export enum IconVariant {
  DISABLED = 'disabled',
  INACTIVE = 'inactive',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUSPENSED = 'suspensed',
  WARNING = 'warning',
  PAUSED = 'paused',
}
